import styled from '@emotion/styled';
import { BreakpointsEnum } from '../../../../helpers/breakpoints';

export const DreamLinesPackageLink = styled.div`
    text-decoration: none !important;
    margin-top: 20px;
    border-radius: 6px;
    overflow: hidden;
    &.onlyMobileVisible {
        display: unset;
        @media (min-width: ${BreakpointsEnum.md}) {
            display: none;
        }
    }
`;

export const DreamLinesPackageBanner = styled.div`
    width: 100%;
    display: flex;
    margin: 0 auto;
    max-width: 1150px;
`;

export const LogoContainer = styled.div`
    width: 50%;
    padding: 13px 0;
    @media (min-width: ${BreakpointsEnum.md}) {
        width: 325px;
        padding: 16px 0;
    }
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => props.theme.background.brandColor2};
    img {
        max-width: 120px;
        width: calc(100% - 50px);
        transform: translateX(-5px);
        @media (min-width: ${BreakpointsEnum.md}) {
            max-width: unset;
            width: 167px;
            transform: translateX(-10px);
        }
    }
    #plus-icon {
        right: 0;
        top: 50%;
        width: 30px;
        height: 30px;
        display: flex;
        color: ${(props) => props.theme.background.brandColor4};
        font-size: 36px;
        position: absolute;
        align-items: center;
        background-color: white;
        justify-content: center;
        transform: translate(50%, -50%);
        border-radius: 6px;
        @media (min-width: ${BreakpointsEnum.md}) {
            width: 40px;
            height: 40px;
            font-size: 45px;
        }
    }
`;

export const InfoContainer = styled.div`
    width: 50%;
    display: flex;
    align-items: center;
    background-color: ${(props) => props.theme.background.brandColor4};
    color: ${(props) => props.theme.text.color.primaryInverse};
    padding: 13px 15px 13px 20px;
    justify-content: space-between;
    @media (min-width: ${BreakpointsEnum.md}) {
        flex: 1;
        width: unset;
        padding: 16px 25px 16px 50px;
    }
    #info-contianer__inner {
        display: none;
        @media (min-width: ${BreakpointsEnum.md}) {
            display: unset;
        }
        #disclaimer {
            margin-top: 0;
            font-size: 13px;
            font-weight: 600;
            margin-bottom: 15px;
        }
        #included-services {
            display: flex;
            align-items: center;
            .included {
                display: flex;
                font-size: 14px;
                font-weight: 600;
                margin-right: 12px;
                align-items: center;
                svg {
                    margin-right: 3px;
                    fill: ${(props) => props.theme.text.color.primaryInverse};
                }
                span {
                    transform: translateY(2px);
                }
            }
        }
    }
    #go-to-package {
        width: 100%;
        display: flex;
        margin: 0 auto;
        font-size: 12px;
        cursor: pointer;
        position: relative;
        align-items: center;
        justify-content: center;

        @media (min-width: ${BreakpointsEnum.md}) {
            width: auto;
            min-width: 200px;
            padding: 3px 10px;
            margin: unset;
            margin-left: 20px;
        }
    }
`;

export const MobilePrice = styled.span`
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    display: flex;
    align-items: center;

    b {
        padding: 0 4px;
    }

    svg {
        fill: #fff;
        margin-left: 8px;
    }
`;

export const MobileIncludedServices = styled.div`
    display: flex;
    color: ${(props) => props.theme.text.color.primaryInverse};
    font-size: 11px;
    flex-wrap: wrap;
    padding: 6px 0px 0px;
    background-color: ${(props) => props.theme.background['brandColor4-90']};
    justify-content: space-evenly;
    @media (min-width: ${BreakpointsEnum.md}) {
        display: none;
    }
    .included-mobile {
        display: flex;
        padding: 0 15px 6px;
        align-items: center;
        svg {
            margin-right: 6px;
            fill: ${(props) => props.theme.text.color.primaryInverse};
        }
    }
`;
